module.exports = __webpack_public_path__ + "img/order-case04.a0f2ca0d.jpeg";